import { Box, Button, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNotification } from "../../../hooks/use-notification";
import { BoxRow, MainContainer, MainContent } from "../../DataEntry/StyledFields";
import logo from "../../../images/logo.png";

const VerifyVoucherForm = ({ title, endpointFn, onSuccess }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [voucherNumber, setVoucherNumber] = useState("");
  const { set: setNotification } = useNotification();
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState("");

  const sendRequest = () => {
    // Check if all required field is populated.
    if (firstName.length === 0) {
      setError("First name is a required field.");
    } else if (lastName.length === 0) {
      setError("Last name is a required field.");
    } else {
      setInProgress(true);
      const formData = {
        firstName: firstName,
        lastName: lastName,
        voucherNumber: voucherNumber,
      };

      axios
        .post(endpointFn(), formData)
        .then(function (response) {
          const [done, message] = onSuccess(response.data, formData);
          if (!done) {
              setNotification({
                message: message,
                type: "error",
              });
              setInProgress(false);
          }
        })
        .catch(function (error) {
          console.log(error);
          setNotification({
            message: `Error ${error.message}`,
            type: "error",
          });
          setInProgress(false);
        });
    }
  };

  return (
    <MainContainer>
      <MainContent>
        <Box sx={{ my: 4, width: "100%", textAlign: "center" }}>
          <img src={logo} width="200px" alt="logo" />
        </Box>

        <Box sx={{ width: "600px", margin: "0 auto" }}>
          <BoxRow>
            <Typography variant="h3">{ title }</Typography>
          </BoxRow>
          <BoxRow>
            <Typography variant="h5">
              Please provide your name and voucher number as it appears in your email:
            </Typography>
          </BoxRow>
          <BoxRow>
            <TextField
              label="Voucher #"
              value={voucherNumber}
              onChange={(e) => setVoucherNumber(e.target.value)}
              margin="dense"
              fullWidth
              variant="outlined"
              required
            />
          </BoxRow>
          <BoxRow>
            <TextField
              label="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              margin="dense"
              fullWidth
              variant="outlined"
              required
            />
          </BoxRow>
          <BoxRow>
            <TextField
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              margin="dense"
              fullWidth
              variant="outlined"
              required
            />
          </BoxRow>
          <BoxRow>
            <Typography
              variant="error"
              color="error"
              style={{ marginTop: "12px" }}
            >
              &nbsp;&nbsp;{error}
            </Typography>
          </BoxRow>
          <BoxRow>
            <Button
              fullWidth
              type="button"
              variant="contained"
              disabled={inProgress}
              onClick={(e) => sendRequest()}
            >
              Submit
            </Button>
          </BoxRow>
        </Box>
      </MainContent>
    </MainContainer>
  );
};

export default VerifyVoucherForm;
